import { LorenMeteringType } from "../../../../features/loren-assets/interfaces/loren-metering-type";
import { LorenMeteringContext } from "../../../../features/loren-assets/enums/loren-metering-context.enum";

export const LorenMetricIcons = new Map([
  [LorenMeteringType.BAROMETRIC_PRESSURE_SENSOR, "pressure"],
  [LorenMeteringType.BATTERY_VOLTAGE_SENSOR, "voltage"],
  [LorenMeteringType.CO2_SENSOR, "co2"],
  [LorenMeteringType.CURRENT_SENSOR, "current"],
  [LorenMeteringType.DISTANCE_SENSOR, "distance"],
  [LorenMeteringType.EXTERNAL_CURRENT_SENSOR, "current"],
  [LorenMeteringType.EXTERNAL_VOLTAGE_SENSOR, "voltage"],
  [LorenMeteringType.FILL_LEVEL_SENSOR, "fluid_flow"],
  [LorenMeteringType.FLUID_FLOW_SENSOR, "fluid_flow"],
  [LorenMeteringType.HCHO_SENSOR, "hcho"],
  [LorenMeteringType.HUMIDITY_SENSOR, "humidity"],
  [LorenMeteringType.ILLUMINATION_SENSOR, "light"],
  [LorenMeteringType.LIGHT_SENSOR, "light"],
  [LorenMeteringType.OZONE_SENSOR, "ozone"],
  [LorenMeteringType.PRESENCE_BEACON, "presence_beacon"],
  [LorenMeteringType.PRESENCE_SENSOR, "presence_sensor"],
  [LorenMeteringType.PM10_SENSOR, "dust"],
  [LorenMeteringType.PM2_5_SENSOR, "dust"],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR, "soil_moisture"],
  [LorenMeteringType.SOIL_TEMPERATURE_SENSOR, "soil_temperature"],
  [LorenMeteringType.TEMPERATURE_SENSOR, "temperature"],
  [LorenMeteringType.TVOC_SENSOR, "tvoc"],
  [LorenMeteringType.VOLTAGE_SENSOR, "voltage"],
  [LorenMeteringType.ARCING_SENSOR, "voltage"],
  [LorenMeteringType.NTL_SENSOR, "voltage"],
  [LorenMeteringType.ELECTRICAL_CONDUCTIVITY_SENSOR, "voltage"],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR_VWC, "soil_moisture"],
]);

export const LorenMetricIconsBinary = new Map<
  LorenMeteringType | LorenMeteringContext,
  { true: string; false: string }
>([
  [LorenMeteringType.BINARY_SENSOR, { true: "door_true", false: "door_false" }],
  [LorenMeteringContext.STATE, { true: "state", false: "state" }],
  [
    LorenMeteringType.LIGHT_BINARY_SENSOR,
    { true: "light_true", false: "light_false" },
  ],
  [
    LorenMeteringType.MOVEMENT_SENSOR,
    { true: "movement_true", false: "movement_false" },
  ],
  [
    LorenMeteringType.PIR_BINARY_SENSOR,
    { true: "movement_true", false: "movement_false" },
  ],
  [
    LorenMeteringType.SMOKE_DETECTOR,
    { true: "smoke_true", false: "smoke_false" },
  ],
  [
    LorenMeteringType.DOOR_WINDOW_BINARY_SENSOR,
    { true: "lock_locked", false: "lock_unlocked"},
  ],
  [
    LorenMeteringType.IGNITION_BINARY_SENSOR,
    { true: "ignition_true", false: "ignition_false" },
  ],
  [
    LorenMeteringType.WATER_LEAK_BINARY_SENSOR,
    { true: "water_leak_true", false: "water_leak_false" },
  ],
  [
    LorenMeteringType.SMOKE_BINARY_SENSOR,
    { true: "smoke_true", false: "smoke_false" },
  ],
  [
    LorenMeteringType.TILT_BINARY_SENSOR,
    { true: "tilt_true", false: "tilt_false" },
  ],
]);

export const LorenMetricBinaryValues = new Map<
  LorenMeteringType | LorenMeteringContext,
  { true: string; false: string }
>([
  [
    LorenMeteringType.BINARY_SENSOR,
    { true: "asset.closed", false: "asset.opened" },
  ],
  [
    LorenMeteringContext.STATE,
    { true: "asset.state_on", false: "asset.state_off" },
  ],
  [
    LorenMeteringType.LIGHT_BINARY_SENSOR,
    { true: "asset.light_true", false: "asset.light_false" },
  ],
  [
    LorenMeteringType.MOVEMENT_SENSOR,
    { true: "asset.general_true", false: "asset.general_false" },
  ],
  [
    LorenMeteringType.PIR_BINARY_SENSOR,
    { true: "asset.general_true", false: "asset.general_false" },
  ],
  [
    LorenMeteringType.SMOKE_DETECTOR,
    { true: "asset.general_true", false: "asset.general_false" },
  ],
  [
    LorenMeteringType.DOOR_WINDOW_BINARY_SENSOR,
    { true: "asset.closed", false: "asset.opened" },
  ],
  [
    LorenMeteringType.IGNITION_BINARY_SENSOR,
    { true: "asset.ignition_true", false: "asset.ignition_false" },
  ],
  [
    LorenMeteringType.WATER_LEAK_BINARY_SENSOR,
    { true: "asset.water_leak_true", false: "asset.water_leak_false" },
  ],
  [
    LorenMeteringType.SMOKE_BINARY_SENSOR,
    { true: "asset.general_true", false: "asset.general_false" },
  ],
  [
    LorenMeteringType.TILT_BINARY_SENSOR,
    { true: "asset.tilt_true", false: "asset.tilt_false" },
  ],
]);
